import React, { useEffect, createElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SalesPageV5 } from './pages/SalesPageV5';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-558L5RR8');`;
    document.head.appendChild(gtmScript);
  }, []);
  return <Routes data-id="element-0">
      <Route path="/" element={<>
            <SalesPageV5 data-id="element-2" />
            <RecentPurchaseToast priceOverrides={[{
        product: 'NutriPeques',
        price: '$19.999 ARS',
        weight: 0.2
      }, {
        product: 'NutriPeques + 1',
        price: '$29.498 ARS',
        weight: 0.4
      }, {
        product: 'NutriPeques + 2',
        price: '$38.997 ARS',
        weight: 0.4
      }]} data-id="element-3" />
          </>} data-id="element-1" />
    </Routes>;
}